document.addEventListener("DOMContentLoaded", function(event) {
  const accordion = document.querySelectorAll(".accordion__wrapper");

  if (accordion.length === 0) {
    return;
  }

  accordion.forEach(item => {
    const accordionItem = item.querySelectorAll(".accordion__item");

    if (accordionItem.length === 0) {
      return;
    }

    accordionItem.forEach(accordionItem => {
      accordionItem.addEventListener("click", function() {
        accordionItem.classList.toggle("accordion__item--closed");
      });
    });
  });
});
